import * as React from "react";
const SvgBack = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.83 5.17a.75.75 0 0 1 0 1.06l-5.02 5.02H21a.75.75 0 0 1 0 1.5H4.81l5.02 5.02a.75.75 0 1 1-1.06 1.06l-6.3-6.3a.75.75 0 0 1 0-1.06l6.3-6.3a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  }
));
export default SvgBack;
